import React, { useState, useEffect } from "react";
import { atom, useRecoilState, useResetRecoilState } from "recoil";
import { userAtom } from "../atoms/userAtom";


function UserLoader() {
	const [user, setUser] = useRecoilState(userAtom)
	const resetUser = useResetRecoilState(userAtom)

	useEffect(() => {
		updateUserAtom(window.REACT_APP_USER_OBJ)
	}, []);

	const updateUserAtom = (userObj) => {
		if (userObj) {
			setUser({
				...user,
				id: 			userObj.ID,
				emailData : {
					...user.emailData,
					email: 			userObj.email,
					emailConfirmed: userObj.emailConfirmed,
				},
				firstName: 		userObj.firstName,
				lastName: 		userObj.lastName,
				roles: 			userObj.roles
			})
		} else {
			resetUser()
		}
	};

	return '';
}

export default UserLoader;
